{"title":"{{ pet_name }} est un ...","dog":"Chien","cat":"Chat"}